import { Modal, View, Text, Pressable, ActivityIndicator } from "react-native"
import { Image } from "expo-image"
import MaterialDesignIcons from "@react-native-vector-icons/material-design-icons"
import { ar } from "i18n/ar"

interface ImagePreviewModalProps {
  visible: boolean
  imageUri: string | null
  onClose: () => void
  onConfirm: () => void
  onRemoveBackground?: () => void
  isProcessing: boolean
  isUploading?: boolean
}

export function ImagePreviewModal({ visible, imageUri, onClose, onConfirm, onRemoveBackground, isProcessing, isUploading }: ImagePreviewModalProps) {
  if (!imageUri) return null

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View className="flex-1 justify-center items-center bg-black/50 p-4">
        <View className="bg-white rounded-lg p-4 w-full max-w-md shadow-xl">
          <View className="flex-row justify-between items-center mb-4">
            <Text className="text-lg font-bold text-gray-900">{ar.previewImage}</Text>
            <Pressable onPress={onClose} disabled={isProcessing || isUploading}>
              <MaterialDesignIcons name="close" size={24} color="#6B7280" />
            </Pressable>
          </View>

          <View className="aspect-square w-full bg-gray-100 rounded-lg overflow-hidden mb-4 relative">
            <Image
              source={{ uri: imageUri }}
              style={{ width: "100%", height: "100%" }}
              contentFit="contain"
              transition={250}
              loading="lazy"
              cachePolicy="memory"
            />
            {isProcessing && (
              <View className="absolute inset-0 justify-center items-center bg-white/50">
                <ActivityIndicator size="large" color="#0000ff" />
              </View>
            )}
          </View>

          <View className="gap-3">
            {onRemoveBackground && (
              <Pressable
                onPress={onRemoveBackground}
                disabled={isProcessing || isUploading}
                className={`flex-row justify-center items-center py-3 px-4 rounded-lg border border-blue-200 bg-blue-50 active:bg-blue-100 ${
                  isProcessing || isUploading ? "opacity-50" : ""
                }`}
              >
                <MaterialDesignIcons name="image-edit" size={20} color="#2563EB" style={{ marginRight: 8 }} />
                <Text className="text-blue-700 font-medium">{ar.removeBackground}</Text>
              </Pressable>
            )}

            <View className="flex-row gap-3 mt-2">
              <Pressable onPress={onClose} disabled={isProcessing || isUploading} className="flex-1 py-3 px-4 rounded-lg bg-gray-100 active:bg-gray-200">
                <Text className="text-gray-700 font-medium text-center">{ar.cancel}</Text>
              </Pressable>

              <Pressable
                onPress={onConfirm}
                disabled={isProcessing || isUploading}
                className={`flex-1 py-3 px-4 rounded-lg bg-green-600 active:bg-green-700 relative items-center ${isProcessing || isUploading ? "opacity-50" : ""}`}
              >
                <Text className={`text-white font-medium text-center ${isUploading ? "opacity-0" : ""}`}>{ar.save}</Text>
                {isUploading && <ActivityIndicator className="absolute top-0 left-0 right-0 bottom-0" color="white" />}
              </Pressable>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  )
}
